import { AirtableProxiApi } from "~/solidJs/shared/api/AirtableProxyApi";
import { queryClient } from "~/solidJs/shared/api/queryClient";

export type IPromptBaseItem = {
	prompt: string;
};
export type IPromptBaseAirtableItem = {
	Prompt: string;
	promptToGlobalId: string | undefined;
};
export type IAirtablePromptBase = {
	basePrompts: IPromptBaseItem[];
	[key: string]: IPromptBaseItem[];
};
let AirtablePromptBaseResolve: (data: IAirtablePromptBase) => void;
export const AirtablePromptBasePromise = new Promise<IAirtablePromptBase>((resolve) => {
	AirtablePromptBaseResolve = resolve;
});
export let AirtablePromptBase: IAirtablePromptBase = { basePrompts: [] };
export const fetchPromptBase = async (): Promise<IAirtablePromptBase> => {
	AirtablePromptBase = {
		basePrompts: []
	};
	const query = await queryClient.fetchInfiniteQuery({
		queryKey: [AirtableProxiApi.hintsPaginationKey],
		queryFn: (props) =>
			AirtableProxiApi.getHintsPagination(props.pageParam.limit, props.pageParam.offset),
		getNextPageParam: (lastPage) => ({
			offset: lastPage.offset,
			limit: lastPage.records.length > 0 ? 999 : 10
		}),
		pages: 2,
		initialPageParam: {
			limit: 10,
			offset: 0
		}
	});
	for (const page of query.pages) {
		for (const record of page.records) {
			const item: IPromptBaseItem = {
				prompt: record.fields.Prompt
			};
			const groupToGlobalID = record.fields.promptToGlobalId;

			if (groupToGlobalID) {
				if (!(groupToGlobalID in AirtablePromptBase)) {
					AirtablePromptBase[groupToGlobalID] = [];
				}
				AirtablePromptBase[groupToGlobalID].push(item);
				continue;
			}
			AirtablePromptBase.basePrompts.push(item);
		}
	}
	AirtablePromptBaseResolve(AirtablePromptBase);
	return AirtablePromptBase;
};
